import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { UtilsService } from 'app/services/utils.service';
import { VisitingHoursDepartmentResource } from 'app/models/VisitingHoursDepartmentResource';
import { forkJoin, Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { NotificationsService } from 'angular2-notifications';
import { VisitingHoursFieldsListResource } from 'app/models/VisitingHoursFieldsListResource';
import { VisitingHoursFieldsResource } from 'app/models/VisitingHoursFieldsResource';
import { DragulaService } from 'ng2-dragula';
import { KioskListResource } from 'app/models/KioskListResource';
import { KioskResource } from 'app/models/KioskResource';
import { FilterCriteriaListEdt } from 'app/models/FilterCriteriaListEdt';
import { FilterCriteriaEDT } from 'app/models/FilterCriteriaEDT';
import { VisitingHoursDepartmentAndKioskResource } from 'app/models/VisitingHoursDepartmentAndKioskResource';
import { Validators, FormBuilder } from '@angular/forms';

@Component({
  selector: 'vbn-add-edit-department',
  templateUrl: './add-edit-department.component.html',
  styleUrls: ['./add-edit-department.component.scss']
})
export class AddEditDepartmentComponent implements OnInit, OnDestroy {

  selected_language: string;
  department: VisitingHoursDepartmentResource;
  departmentRid: any;
  addressParams: any;
  errorMessage: any;
  userEmail: string;
  fields: VisitingHoursFieldsResource[];
  subscription: Subscription;
  kiosksList: KioskListResource;
  filterCriteria: FilterCriteriaListEdt;
  checkList: any;
  checkObject: any;
  kioskListResource: KioskResource[];
  arrayToSend: any;
  saveErrors: boolean = false;

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private service: UtilsService,
    private translate: TranslateService,
    private _notificationService: NotificationsService,
    private dragula: DragulaService,
    private fb: FormBuilder) {

    this.selected_language = "ro";
    this.department = new VisitingHoursDepartmentResource;
    this.department.visitingHoursFiledsResource = this.fields = [];

    this.subscription = this.dragula.drop.subscribe(value => {
      this.changeOrderIndex(value);
    });
    this.kiosksList = new KioskListResource();
    this.kiosksList.list = new Array<KioskResource>();
    this.filterCriteria = new FilterCriteriaListEdt();
    this.filterCriteria.filters = new Array<FilterCriteriaEDT>();
    this.checkList = new Array();
    this.kioskListResource = new Array();
    this.arrayToSend = new Array();
  }

  ngOnInit() {
    this.userEmail = this.service.currentUserEmail;
    this.getKioskList();
    if (this.router.url != '/add-category') {
      this.activatedRoute.params.subscribe((params: Params) => {
        if ('json' in params) {
          this.addressParams = JSON.parse(atob(params['json']));
          this.departmentRid = this.addressParams.departmentRid;

        }
      });
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  getKioskList() {
    this.service.add('/admin/kiosk/getAll?userEmail=' + this.userEmail, this.filterCriteria)
      .subscribe(
        response => {
          this.kiosksList = response;
          if (this.kiosksList.errorCode == 1002) {
            forkJoin(
              [this.translate.get('Error'),
              this.translate.get('0 items found after the search!')]
            ).subscribe((res) => {
              this._notificationService.create(res[0], res[1], 'error')
            });
            this.kiosksList = new KioskListResource();
            this.filterCriteria.filters = new Array<FilterCriteriaEDT>();
            this.kiosksList.list = [];
          }
          this.initializationKioskList();
        },
        error => this.errorMessage = <any>error);
  }

  initializationKioskList() {
    if (this.kiosksList.list == null) {
      this.kioskListResource = []
    } else {
      this.kioskListResource = this.kiosksList.list;
    }
    this.checkList = new Array();
    for (let i = 0; i < this.kiosksList.list.length; i++) {
      this.checkObject = {};
      this.checkObject.kiosk = new VisitingHoursDepartmentAndKioskResource();
      this.checkObject.kiosk = this.kiosksList.list[i];
      this.checkList.push(this.checkObject);
    }
    this.checkObject = {};
    this.getDepartmentByRid(this.departmentRid);
  }

  updateCheckedOptionsKiosk(kiosk, event) {
    if (event.target.checked) {
      let termsOrGdpr = new VisitingHoursDepartmentAndKioskResource()
      termsOrGdpr.kiosk = kiosk;
      this.arrayToSend.push(termsOrGdpr);
    } else {
      for (let i = 0; i < this.arrayToSend.length; i++) {
        if (kiosk.rid == this.arrayToSend[i].kiosk.rid) {
          this.arrayToSend.splice(i, 1);
          return
        }
      }
    }
  }

  getDepartmentByRid(rid) {
    this.service.get(`/admin/visitingHours/departments/getOne/${rid}?userEmail=${this.userEmail}`)
      .subscribe(
        response => {
          this.department = response;
          this.fields = this.department.visitingHoursFiledsResource;
          Object.assign(this.kioskListResource, this.kiosksList)

          this.checkList.forEach(element => {
            let checkKiosk = this.department.kioskResourceList.find(elem => elem.kiosk.rid === element.kiosk.rid);
            if (checkKiosk) {
              element.check = true;
              this.arrayToSend.push(element);
            }
          });
          /* for (let i = 0; i < this.kioskListResource.length; i++) {
            for(let j = 0; j < this.department.kioskResourceList.length; j++) {
              if(this.department.kioskResourceList[j].kiosk.rid == this.kioskListResource[i].rid) {
                for(let k = 0; k < this.checkList.length; k++) {
                  if(this.checkList[k].kiosk.rid == this.kioskListResource[i].rid) {
                    this.checkList[k].check = true;
                    this.arrayToSend.push(this.checkList[k]);
                  }
                }
              }
            }
          } */


          if ([10982, 10983, 10984].indexOf(this.department.errorCode) > 0) {
            forkJoin(
              this.translate.get('Error'),
              this.translate.get(`Get department info error - (${response.errorCode})`)
            ).subscribe((res) => {
              this._notificationService.create(res[0], res[1], 'error')
            })
            this.fields = [];
          }
        },
        error => this.errorMessage = <any>error);
  }

  validationForm = this.fb.group({
    titleRo: ['', [Validators.required, this.service.NoWhitespaceValidator()]],
    titleEn: [''],
    titleFr: [''],
    titleDe: ['']
  })

  edit() {
    this.saveErrors = true
    let errors = false;
    if (!this.validationForm.valid) {
      forkJoin(
        this.translate.get('Mising fields'),
        this.translate.get('Please fill out the fields on all languages!')
      ).subscribe((res) => {
        this._notificationService.create(res[0], res[1], 'error')
      });
      errors = true;
    }
    if (this.arrayToSend.length == 0) {
      forkJoin(
        this.translate.get('Mising fields'),
        this.translate.get('Please check at least 1 kiosk!')
      ).subscribe((res) => {
        this._notificationService.create(res[0], res[1], 'error')
      });
      errors = true;
    }
    if (errors) {
      return;
    }
    (!this.departmentRid) && (this.department.userEmail = this.userEmail);
    this.department.kioskResourceList = this.arrayToSend;
    this.service.add('/admin/visitingHours/departments/edit', this.department)
      .subscribe(
        response => {
          this.department = response;
          if (this.department.errorCode === 10981) {
            forkJoin(
              this.translate.get('Error'),
              this.translate.get(`Add Department name in all languages - (${this.department.errorCode})`)
            ).subscribe((res) => {
              this._notificationService.create(res[0], res[1], 'error')
            })
          } else {
            if (this.department.errorCode === 10990) {
              forkJoin(
                this.translate.get('Error'),
                this.translate.get(`Add Department - Unknown user - (${this.department.errorCode})`)
              ).subscribe((res) => {
                this._notificationService.create(res[0], res[1], 'error')
              })
            } else {
              if (this.department.errorCode === 10982 || this.department.errorCode === 10983) {
                forkJoin(
                  this.translate.get('Error'),
                  this.translate.get(`Add Department error - (${this.department.errorCode})`)
                ).subscribe((res) => {
                  this._notificationService.create(res[0], res[1], 'error')
                })
              } else {
                if (this.departmentRid) {
                  forkJoin(
                    this.translate.get('Success'),
                    this.translate.get('Department was successfully edited!')
                  ).subscribe((res) => {
                    this._notificationService.create(res[0], res[1], 'success')
                  });
                } else {
                  forkJoin(
                    this.translate.get('Success'),
                    this.translate.get('Department was successfully created!')
                  ).subscribe((res) => {
                    this._notificationService.create(res[0], res[1], 'success')
                  });
                }
                window.scrollTo(500, 0);
                this.router.navigate(['/visiting-departments']);
              }
            }
          }


        },
        error => this.errorMessage = <any>error);
  }

  editField(rid) {
    window.scrollTo(500, 0);
    this.router.navigate(['/edit-department-field/' + btoa('{ "fieldRid" : "' + rid + '","departmentRid" : "' + this.departmentRid + '"}')]);
  }

  deleteField(rid) {
    this.service.get('/admin/visitingHours/fields/delete/' + rid)
      .subscribe(
        response => {
          forkJoin(
            this.translate.get('Success'),
            this.translate.get('Field was deleted!')
          ).subscribe((res) => {
            this._notificationService.create(res[0], res[1], 'success')
          })
          this.getDepartmentByRid(this.departmentRid);
        },
        error => this.errorMessage = <any>error);
  }


  changeOrderIndex(value: any) {
    let rid = value[1].getAttribute("field-rid")
    let oldPos = parseInt(value[1].getAttribute("index"))
    let newPos = undefined
    let departmentList = value[2].children;

    for (let i = 0; i < departmentList.length; i++) {
      let k = departmentList[i].getAttribute("field-rid")
      if (rid == k) {
        newPos = i
        break;
      }
    }

    this.service.add(`/admin/visitingHours/fields/shift?oldPosition=${oldPos}&newPosition=${newPos}&departmentId=${this.departmentRid}`, null)
      .subscribe(
        response => {
          if ([10982, 10989].indexOf(response.errorCode) > 0) {
            forkJoin(
              this.translate.get('Chance Order error'),
              this.translate.get('The order was not changed')
            ).subscribe((res) => {
              this._notificationService.create(res[0], res[1], 'error')
            })
          } else {
            forkJoin(
              this.translate.get('Success'),
              this.translate.get('Department order was changed!')
            ).subscribe((res) => {
              this._notificationService.create(res[0], res[1], 'success')
            })
          }
          this.getDepartmentByRid(this.departmentRid);
        },
        error => this.errorMessage = <any>error);

    setTimeout(() => {
      console.log('------');
    }, 1000);
  }

  showResponsiveDetails(kioskId) {
    const width = window.innerWidth;
    if (width <= 1100) {
      for (let i = 0; i < this.kiosksList.list.length; i++) {
        if (this.kiosksList.list[i].rid == kioskId) {
          this.kiosksList.list[i].showDetailsOnResponsive = !this.kiosksList.list[i].showDetailsOnResponsive;
        }
        else {
          this.kiosksList.list[i].showDetailsOnResponsive = false;
        }
      }
    }
    else {
      return;
    }

  }

}
